import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=1caa5e89&scoped=true"
import script from "./CalendarIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalendarIcon.vue?vue&type=style&index=0&id=1caa5e89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa5e89",
  null
  
)

export default component.exports